module.exports = __webpack_public_path__ + "4be195a6aeb107bdaa976b3c0ca4074c.svg";